/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import AccordionControl from 'app/components/common/AccordionControl.jsx';
import classnames from 'classnames';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ListModule from 'app/mixins/ListModule.js';
import RouteDetailModule from 'app/mixins/RouteDetailModule.jsx';
import SocialButton from 'app/components/common/SocialButton.jsx';
import Loading from 'app/components/common/Loading.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import UserMessageModule from 'app/modules/UserMessageModule.js';
import * as _ from 'underscore';
import Utilities from 'app/utility/Utilities.js';
import { FormattedDate } from 'react-intl';
import { FormattedTime } from 'react-intl';
import { compose } from 'redux';
import { Breakpoint } from 'react-socks';

class CurationInputItem extends React.Component {
    constructor(props) {
        super(props);

		this.confirmDeleteFeed = this.confirmDeleteFeed.bind(this);
		this.refreshFeed = this.refreshFeed.bind(this);
		this.activeFeedToggle = this.activeFeedToggle.bind(this);
		this.viewFeed = this.viewFeed.bind(this);
		this.showLog = this.showLog.bind(this);

    }

    confirmDeleteFeed(e) {

        let cancelCallback = () => {
				this.props.closeAllModals();
			},
			confirmCallback = () => {
				this.props.deleteMethod(this.props.input.id);
				this.props.closeAllModals();
				this.props.router.navigate('/share/curate/feeds/list');
			},
			modal = null;


		modal = (
            <DeleteModal
				modalCopy={"Are you sure you want to delete this Curated Feed?"}
				cancelAction={cancelCallback}
				confirmAction={confirmCallback} />
        );

        this.props.addModal(modal);

    }

    refreshFeed() {

		this.props.refreshInput(this.props.input.id);

    }

    activeFeedToggle(e) {

        let feedId = e.currentTarget.dataset.id,
            active = e.currentTarget.dataset.togglestate === 'true' ? 0 : 1,
            constants = this.props.app.config.constants,
            firstPullFlag = null,
            canActivate = true;

        if (active) {
            if ([constants.INPUT_TYPE_TWITTER, constants.INPUT_TYPE_INSTAGRAM, constants.INPUT_TYPE_INSTAGRAM_BUSINESS].indexOf(parseInt(this.props.input.type)) !== -1) {
                if (this.props.input.sysActionFlag && parseInt(this.props.input.sysActionFlag, 10) === 1) {
                    canActivate = false;
                }
            }
            firstPullFlag = constants.FIRSTPULL_ON;
        } else {
            let input = Utilities.deepClone(this.props.input);
            input.activeFlag = 0;
            this.props.updateCurationInput(input);
            return;
        }

        if (canActivate) {
			let input = Utilities.deepClone(this.props.input);
			input.activeFlag = 1;
			input.firstPullFlag = firstPullFlag;
            this.props.updateCurationInput(input);
        } else {
            this.setState({
                detailError: 'Reconnect your feed before activating it'
            });
        }

    }

    viewFeed(e) {
        let url = e.currentTarget.dataset.url,
            constants = this.props.app.config.constants;

        if (this.props.input.type === constants.INPUT_TYPE_FEED) {
            url = '/feedPreview.php?url=' + e.currentTarget.dataset.url + (this.props.input.useCachebuster !== undefined && this.props.input.useCachebuster === true ? '&cb=1' : '');
        }

        window.open(url);
    }

    showLog(e) {

        this.props.router.navigate('/share/curate/feeds/log/' + e.currentTarget.dataset.id);

    }

    render() {

        let InputIcon = null,
        	status = {},
        	inactive = !this.props.input.activeFlag,
        	itemClass = classnames(
                'dlvr-list-item',
                'simple', {
                    'detail': this.props.showDetail ? true : false,
                    'inactive': !this.props.route.activeFlag,
                    'blur': this.props.showDetail ? true : false
                }
            ),
        	itemNameClass = classnames(
                'item-input-label', {
                    'inactive': inactive
                }
            ),
        	itemStatusClass = classnames(
                'item-status-label', {
                    'inactive': inactive
                }
            ),
        	detailBlock = null,
			input = null,
        	inputImg = null,
			inputImgSrc = null,
        	statusBlock = null,
        	activeFlag = !inactive,
        	statusClass = '',
        	reconnectButton = null,
        	constants = this.props.app.config.constants,
        	accordionOpen = false,
            buttons = {
                toggle: null,
                refresh: null,
                view: null,
                logs: null,
                reconnect: null,
                delete: null
            },
            item = null,
            lastItemTitle = 'Most recent item from this feed';

		InputIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.input.type)];
        if (this.props.input.subtype) {
            InputIcon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.input.subtype)];
        }

        inputImgSrc = [this.props.app.config.assetsUrl, 'images', 'img404.png'].join('/');

        inputImg = new Image();
        inputImg.onerror = function() {
            this.src = inputImgSrc;
        };
        inputImg.src = this.props.input.lastItem &&
            this.props.input.lastItem.pictureUrls &&
            this.props.input.lastItem.pictureUrls.length ?
            this.props.input.lastItem.pictureUrls[0] : inputImgSrc;

        if (this.props.showDetail && this.props.input.lastItem !== undefined) {
            input = this.props.input;
            let messages = this.props.getApiErrors(['INPUT_UPDATE, INPUT_REFRESH']);
			let itemPullDate = null;

            // if no errors, check for app messages
            if (messages.length === 0) {
                messages = this.props.getAppMessages(['INPUT_UPDATE', 'INPUT_REFRESH']);
            }

			if (this.props.input.lastPullInfo && this.props.input.lastPullInfo.length) {
				itemPullDate = moment(this.props.input.lastPullInfo[0].unixTs * 1000).tz(this.props.user.detail.timezone).format("MMMM D, YYYY");
			}

            accordionOpen = true;

            if ([constants.INPUT_TYPE_TWITTER, constants.INPUT_TYPE_INSTAGRAM, constants.INPUT_TYPE_INSTAGRAM_BUSINESS].indexOf(parseInt(input.type, 10)) !== -1) {
                buttons.reconnect = (
                    <div className="detail-button" onClick={this.props.reauthorizeInput} data-id={input.id} data-serviceid={input.type} role='button' aria-label='reconnect'>
						<div className="button-icon">
							<i className="fa fa-refresh"></i>
						</div>
						<div className="button-label">
							Reconnect
						</div>
					</div>
                );
            }

            statusBlock = this.props.generateDetailStatusBlock(input, messages);


            buttons.toggle = (
                <div className="detail-toggle">
                    <ToggleControl active={activeFlag} callback={this.activeFeedToggle} data-id={input.id} />
                </div>
            );

            buttons.refresh = (
                <div className="detail-button" onClick={this.props.refreshFeed} data-id={input.id} role="button" aria-label="refresh">
                    <div className="button-icon">
                        <i className="fa fa-refresh"></i>
                    </div>
                    <div className="button-label">
                        Refresh
                    </div>
                </div>
            );

            buttons.view = (
                <div className="detail-button" onClick={this.viewFeed} data-url={encodeURIComponent(input.url)} role="button" aria-label="preview">
                    <div className="button-icon">
                        <i className="fa fa-external-link"></i>
                    </div>
                    <div className="button-label">
                        Preview
                    </div>
                </div>
            );

            buttons.logs = (
                <div className="detail-button" onClick={this.showLog} data-id={input.id} role="button" aria-label="show logs">
                    <div className="button-icon">
                        <i className="fa fa-archive"></i>
                    </div>
                    <div className="button-label">
                        Logs
                    </div>
                </div>
            );

            buttons.delete = (
                <div className="detail-button" onClick={this.confirmDeleteFeed} role="button" aria-label="delete">
                    <div className="button-icon">
                        <i className="fa fa-trash-o"></i>
                    </div>
                    <div className="button-label">
                        Delete
                    </div>
                </div>
            );

            if (!_.isEmpty(this.props.input.lastItem)) {
                item = (
                    <div>
                        <div className="item-image curate-item-image">
                            <img src={inputImg.src} />
                        </div>
                        <div className="item-details curate-item-details">
                            <div className="item-source curate-item-source">
                                {itemPullDate}
                            </div>
                            <div className="item-title curate-item-title">
                                <div className="item-title-text">
                                    {this.props.input.lastItem.title}
                                </div>
                                <a href={this.props.input.lastItem.longUrl} target="_blank">view</a>
                            </div>
                        </div>
                    </div>
                );
            } else {
                item = (
                    <div>
                        <div className="item-details curate-item-details">
                            <div className="item-title curate-item-title">
                                No new items have been posted
                            </div>
                        </div>
                    </div>
                );
                lastItemTitle = '';
            }

            detailBlock = (
				<div>
                    <Breakpoint desktop only>
    					<div className="detail-controls">
    						{buttons.toggle}
    						<div className="detail-buttons">
    							{buttons.refresh}
    							{buttons.view}
    							{buttons.logs}
    							{buttons.reconnect}
    							{buttons.delete}
    						</div>
    					</div>
                    </Breakpoint>
                    <Breakpoint mobile only>
                        <div className="detail-controls mobile">
                            <div className="detail-control-row">
                                {buttons.toggle}
    							{buttons.delete}
                            </div>
                            <div className="detail-control-row">
                                {buttons.reconnect}
                                {buttons.refresh}
    							{buttons.view}
    							{buttons.logs}
                            </div>
                        </div>
                    </Breakpoint>
					{statusBlock}
					<div className="item-row curate-feed-item-row" onMouseOver={this.itemRowMouseOver} onMouseLeave={this.itemRowMouseOut}>
						{lastItemTitle}
                        <Breakpoint desktop only>
                            <div className="item">
                                {item}
                            </div>
                        </Breakpoint>
                        <Breakpoint mobile only>
                            <div className="item mobile">
                                {item}
                            </div>
                        </Breakpoint>
					</div>
				</div>
			);
        }

        let lastPull = null;
        if (this.props.input.lastPullTs !== undefined) {
            lastPull = this.props.input.lastPullTs;
        } else if (_.isArray(this.props.input.lastPullInfo) && this.props.input.lastPullInfo.length) {
            lastPull = this.props.input.lastPullInfo[0].unixTs;
        }

        status = this.props.setStatus(this.props.input.activeFlag, lastPull);
        statusClass = classnames(
            'item-row-cell status',
            status.className, {
                'inactive': inactive
            }
        );

        return (
			<li className={itemClass}>
				<div className="list-item-row" onClick={this.props.detailHandler} data-id={this.props.input.id} role="switch" aria-label="show detail">
					<AccordionControl accordionOpen={accordionOpen} />
					<div className="item-row-cell input-label">
						<div className="item-icon-wrapper">
							<InputIcon round={true} inactive={inactive}/>
						</div>
						<div className={itemNameClass} title={this.props.input.name} alt={this.props.input.name}>
							{this.props.input.name || ''}
						</div>
					</div>
					<div className={statusClass}>
						<span className={itemStatusClass}>
							{status.label}
						</span>
						<span className="item-status-icon">
							{status.icon}
						</span>
					</div>
				</div>
				{detailBlock}
			</li>
        );
    }
};

CurationInputItem.propTypes = {
    detailHandler: PropTypes.func,
    input: PropTypes.object,
    inputDetail: PropTypes.object,
    showDetail: PropTypes.bool,
    refreshFeed: PropTypes.func,
    route: PropTypes.object,
    messages: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	])
};

CurationInputItem.defaultProps = {
    detailHandler: null,
    input: {},
    inputDetail: null,
    showDetail: false,
    curateRouteId: null,
    refreshFeed: null,
    socials: {},
    messages: null,
    route: {},
    detailError: ''
};

const enhance = compose(
    RouteDetailModule,
    ListModule
);

export default enhance(CurationInputItem);
